module.exports = __webpack_public_path__ + "static/media/clock.9fa188da.svg";